import React from 'react';
import { Image, View } from 'react-native';
import { Text } from 'react-native-web';
import { SMS_sent, success_image } from '../../../../../utils/DictionaryManagementUtils';
import { getImageByKey } from '../../../../../utils/ImagesManagementUtils';
import FullPageSimulator from '../../FullPageSimulator';
import LargeTextWithSpecialFont from '../../../AuxiliaryComponent/TextComponent/LargeTextWithSpecialFont';
import { textLink_9_3 } from '../../../AuxiliaryComponent/TextComponent/TextStyle';

const ActionSuccessFP = ({
  globJSON,
  transactions,
  language,
  simPlatform,
  TopTitle,
  withExtraHeightForTitle,
  slideshowRefs,
}) => {
  const myStyles = {
    successLogo: {
      alignSelf: 'center',
      width: 58,
      height: 58,
    },
    linkStyle: {
      paddingVertical: 10,
      textAlign: 'center',
    },
    largeTextContainer: {
      paddingVertical: 10,
      alignSelf: 'center',
    },
  };
  //= ====================================================================
  return (
    <View>
      <FullPageSimulator
        globJSON={globJSON}
        simPlatform={simPlatform}
        TopTitle={TopTitle}
        withExtraHeightForTitle={withExtraHeightForTitle}
        hideArrow
        slideshowRefs={slideshowRefs}
      >
        <Image
          fadeDuration={0}
          resizeMode="contain"
          style={myStyles.successLogo}
          source={getImageByKey(globJSON.configurations.general.success_image, success_image)}
        />
        <View style={myStyles.largeTextContainer}>
          <LargeTextWithSpecialFont
            globJSON={globJSON}
            simPlatform={simPlatform}
            language={language}
            txt={SMS_sent}
          />
        </View>
        {transactions.show_link_transactions_list
              && (<Text style={[textLink_9_3(globJSON, simPlatform), myStyles.linkStyle]}>{transactions.go_account_balance}</Text>)}
      </FullPageSimulator>
    </View>
  );
};

export default ActionSuccessFP;
